/**
 * Hand control back to the browser so pending re-renders and queued input can run.
 * Skipped when the tab is hidden: there is nothing to repaint, and background
 * setTimeout is throttled to ~1s+, which would stall the caller.
 */
export function yieldToBrowser(): Promise<void> {
    if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
        return Promise.resolve();
    }
    const scheduler = (globalThis as { scheduler?: { yield?: () => Promise<void> } }).scheduler;
    if (typeof scheduler?.yield === 'function') {
        return scheduler.yield();
    }
    return new Promise((resolve) => {
        setTimeout(resolve, 0);
    });
}
